import React, { useEffect, useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';
import { Tabs } from '../Tabs';
import { Login } from './flows/Login';
import { SignUp } from './flows/SignUp';
import { OrbitingBackground } from '../OrbitingBackground';
import * as S from './styles';
import { AcceptInvitation } from './flows/AcceptInvitation';
import { Link, Space } from '../atoms';

type Props = {
  currentTab?: 'login' | 'signup';
  routes?: { login?: string; signup?: string };
  defaultRedirectPath?: string;
};

export const PhoneAuthenticationForm: React.FC<Props> = ({
  routes = { login: '/login', signup: '/signup' },
  defaultRedirectPath = '/dashboard',
  currentTab,
}) => {
  const router = useRouter();

  const redirectPath = useMemo(
    () => (router.query?.redirect as string) ?? defaultRedirectPath,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [defaultRedirectPath]
  );

  useEffect(() => {
    for (const route of Object.values(routes)) {
      router.prefetch(route);
    }
  }, [router, routes]);

  const handleTabClick = useCallback(
    (key: string) => {
      const route = routes[key as keyof typeof routes];
      if (route) {
        router.replace(route);
      }
    },
    [router, routes]
  );

  return (
    <OrbitingBackground>
      <S.Wrapper>
        <S.Link href={'/'}>
          <S.LogoDesktop src={'/fullLogo.svg'} />
        </S.Link>

        <S.Card disableFillAvailableHeight>
          <Space direction="vertical" size={0} $fullWidth>
            <Link href={'/'}>
              <S.LogoMobile src={'/logoPurple.svg'} />
            </Link>

            {currentTab ? (
              <S.SpacedTabs
                size="large"
                defaultActiveKey={currentTab}
                onTabClick={handleTabClick}
                centered
              >
                {!!routes['signup'] && (
                  <Tabs.TabPane tab="Sign up" key="signup">
                    <SignUp redirectPath={defaultRedirectPath} />
                  </Tabs.TabPane>
                )}

                {!!routes['login'] && (
                  <Tabs.TabPane tab="Log in" key="login">
                    <Login redirectPath={redirectPath} />
                  </Tabs.TabPane>
                )}
              </S.SpacedTabs>
            ) : (
              <AcceptInvitation redirectPath={redirectPath} />
            )}
          </Space>
        </S.Card>
      </S.Wrapper>
    </OrbitingBackground>
  );
};
